"use client";

import { c as _c } from "react/compiler-runtime";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { INotificationPriorityAlert } from "@/types/feed.types";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationDrop from "../subcomponents/NotificationDrop";
import NotificationHeader from "../subcomponents/NotificationHeader";
import NotificationTimestamp from "../subcomponents/NotificationTimestamp";
import { getIsDirectMessage, useWaveNavigation } from "../utils/navigationUtils";
export default function NotificationPriorityAlert(t0) {
  const $ = _c(44);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const {
    createReplyClickHandler,
    createQuoteClickHandler
  } = useWaveNavigation();
  let t1;
  if ($[0] !== notification.related_identity) {
    t1 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[0] = notification.related_identity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="tw-text-iron-400">sent a priority alert 🚨</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== notification.created_at) {
    t3 = <span className="tw-text-sm tw-font-normal tw-text-iron-50">{t2}{" "}<NotificationTimestamp createdAt={notification.created_at} /></span>;
    $[3] = notification.created_at;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== notification.related_identity || $[6] !== t1 || $[7] !== t3) {
    t4 = <NotificationHeader author={notification.related_identity} actions={t1}>{t3}</NotificationHeader>;
    $[5] = notification.related_identity;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const headerSection = t4;
  if (!notification.related_drops || notification.related_drops.length === 0) {
    let t5;
    if ($[9] !== headerSection) {
      t5 = <div className="tw-w-full tw-flex tw-gap-x-3"><div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{headerSection}</div></div>;
      $[9] = headerSection;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  const drop = notification.related_drops[0];
  if (!drop) {
    return null;
  }
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[11] !== activeDrop || $[12] !== createQuoteClickHandler || $[13] !== createReplyClickHandler || $[14] !== drop || $[15] !== headerSection || $[16] !== onQuote || $[17] !== onReply) {
    const isDirectMessage = getIsDirectMessage(drop.wave);
    t13 = "tw-w-full tw-flex tw-gap-x-3";
    t11 = "tw-w-full tw-flex tw-flex-col tw-space-y-2";
    t12 = headerSection;
    T0 = NotificationDrop;
    t5 = drop;
    t6 = activeDrop;
    t7 = onReply;
    t8 = onQuote;
    t9 = createReplyClickHandler(drop.wave.id, isDirectMessage);
    t10 = createQuoteClickHandler(isDirectMessage);
    $[11] = activeDrop;
    $[12] = createQuoteClickHandler;
    $[13] = createReplyClickHandler;
    $[14] = drop;
    $[15] = headerSection;
    $[16] = onQuote;
    $[17] = onReply;
    $[18] = T0;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    T0 = $[18];
    t10 = $[19];
    t11 = $[20];
    t12 = $[21];
    t13 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  let t14;
  if ($[28] !== T0 || $[29] !== onDropContentClick || $[30] !== t10 || $[31] !== t5 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t14 = <T0 drop={t5} activeDrop={t6} onReply={t7} onQuote={t8} onReplyClick={t9} onQuoteClick={t10} onDropContentClick={onDropContentClick} />;
    $[28] = T0;
    $[29] = onDropContentClick;
    $[30] = t10;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t11 || $[38] !== t12 || $[39] !== t14) {
    t15 = <div className={t11}>{t12}{t14}</div>;
    $[37] = t11;
    $[38] = t12;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t13 || $[42] !== t15) {
    t16 = <div className={t13}>{t15}</div>;
    $[41] = t13;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  return t16;
}